/**
 * min/max範囲に押さえつける
 *
 * @param {integer} min 最小値
 * @param {integer} max 最大値
 * @returns
 */
Number.prototype.clamp = function (min, max) {
  return Math.min(Math.max(this, min), max)
}

/**
 * 少数第n位の扱い
 *
 * @param {integer} digit 少数第n位
 * @returns
 */
Number.prototype.fixed = function (digit = 0) {
  return parseFloat((this + 1 / Math.pow(10, digit)).toFixed(digit))
}
